module.exports = __webpack_public_path__ + "fonts/font.fc9c0ed8.woff2";